import React, { useRef } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

type CardTiltProps = {
  children: React.ReactNode;
  maxTilt?: number;
  className?: string;
};

export const CardTilt: React.FC<CardTiltProps> = ({ children, maxTilt = 15, className }) => {
  const ref = useRef<HTMLDivElement>(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);

  const xSpring = useSpring(x, { stiffness: 200, damping: 20 });
  const ySpring = useSpring(y, { stiffness: 200, damping: 20 });

  const handleMouseMove = (e: React.MouseEvent) => {
    const card = ref.current;
    if (!card) return;
    const rect = card.getBoundingClientRect();
    const cardX = e.clientX - rect.left;
    const cardY = e.clientY - rect.top;
    const rotateY = ((cardX / rect.width) - 0.5) * 0.7 * maxTilt;
    const rotateX = ((cardY / rect.height) - 0.5) * -3 * maxTilt;
    x.set(rotateY);
    // y.set(rotateX);
  };

  const handleMouseLeave = () => {
    x.set(0);
    y.set(0);
  };

  return (
    <motion.div
      ref={ref}
      className={className ? `card-tilt ${className}` : "card-tilt"}
      style={{ perspective: 1000, willChange: "transform" }}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      <motion.div
        className="gsap-tilt-inner"
        style={{
          rotateY: xSpring,
          rotateX: ySpring,
          willChange: "transform",
        }}
      >
        {children}
      </motion.div>
    </motion.div>
  );
};
